import { render, staticRenderFns } from "./LayoutBottom.vue?vue&type=template&id=bf830dae"
import script from "./LayoutBottom.vue?vue&type=script&lang=js"
export * from "./LayoutBottom.vue?vue&type=script&lang=js"
import style0 from "./LayoutBottom.vue?vue&type=style&index=0&id=bf830dae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports